module.exports = __webpack_public_path__ + "img/lander-action-03-wide.5a36a781.webp";